import { SettingSlider } from "./SettingSlider";
import { addOpacityToHex } from "../../helpers";
import { hexToRgba } from "utils";
import { Opacity } from "components/icons/";
import { SliderSingleProps } from "antd";
import { useTranslate } from "@refinedev/core";
import { PaletteResponse } from "pages/media/types";
import { resolveColorToBrandkitColorIfNeeded } from "../../helpers/itemsHelper";
import { DEFAULT_COLOR } from "../../constants";

interface OpacitySliderProps extends Omit<SliderSingleProps, "onChange"> {
  hexColor: string;
  icon?: boolean;
  palette?: PaletteResponse;
  onChange: (heaxColorWithOpacity: string) => void;
  containerStyle?: React.CSSProperties;
}
export const OpacitySlider = ({
  hexColor,
  icon = true,
  palette,
  onChange,
  ...sliderProps
}: OpacitySliderProps) => {
  const t = useTranslate();
  const resolvedColor =
    resolveColorToBrandkitColorIfNeeded(hexColor, palette) ?? DEFAULT_COLOR;
  const resolvedHex =
    typeof resolvedColor === "string" ? resolvedColor : DEFAULT_COLOR;

  const backgroundOpacity = hexToRgba(resolvedHex)[3];
  const opacityInPercentage = Math.round((backgroundOpacity * 100) / 255);

  return (
    <SettingSlider
      value={opacityInPercentage}
      onChange={(value: number) => {
        const backgroundColorWithOpacity = addOpacityToHex(resolvedHex, value);
        onChange(backgroundColorWithOpacity);
      }}
      label={
        icon ? (
          <Opacity size={15} />
        ) : (
          t("components.templates.SettingsToolbar.controls.opacity")
        )
      }
      valueSuffix="%"
      {...sliderProps}
    />
  );
};
